import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import {
  toResponseError,
  type AttachmentAddInput,
  type AttachmentAddSuccess,
  type UnsavedAttachment,
} from '@terros/common'

export function useAddAttachment(): AddHookResponse<UnsavedAttachment, AttachmentAddSuccess> {
  const mutation = useTantalimMutation<AttachmentAddInput, AttachmentAddSuccess>({
    url: '/attachment/add',
  })

  async function add(unsaved: UnsavedAttachment): Promise<AttachmentAddSuccess> {
    try {
      return await mutation.mutateAsync({ attachment: unsaved })
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
